import { FlexBox } from '@dixa/lib-shared-habla';

import { ConversationsTablePreviewButton } from './components/previewButton/conversationsTablePreviewButton';
import { ConversationsTableRowMenu } from './components/rowMenu/conversationsTableRowMenu';
import styles from './conversationsTableActions.module.scss';

/** Represents the content of the actions cell in the conversations table. */
export const ConversationsTableActions = (): JSX.Element => {
  return (
    <FlexBox
      className={styles.container}
      alignItems="center"
      justifyContent="flex-end"
    >
      <ConversationsTablePreviewButton />
      <ConversationsTableRowMenu />
    </FlexBox>
  );
};
